import { render, staticRenderFns } from "./mobilenav.vue?vue&type=template&id=48805c4c&scoped=true"
import script from "./mobilenav.vue?vue&type=script&lang=js"
export * from "./mobilenav.vue?vue&type=script&lang=js"
import style0 from "./mobilenav.vue?vue&type=style&index=0&id=48805c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48805c4c",
  null
  
)

export default component.exports